import { isNil, first } from 'lodash'
import moment from 'moment'

export const humanName = (names, order = 'nameFirst') => {
  if (!names) {
    return ''
  }
  const nm = first(names)
  const given = first(nm?.given)
  const family = first(nm?.family)
  if (order === 'nameFirst') {
    return [ given, family ].join(' ')
  }
  return [ family, given ].join(', ')
}

export const mapNameIdx = chat =>
  (chat.participants || []).reduce((acc, p) => {
    acc[p.id] = humanName(p.name)
    return acc
  }, {})

const debouncedIdx = {}

export const debounce = (key, timeout, fn) => {
  const req = debouncedIdx[key]
  try {
    if (req) {
      clearTimeout(req)
    }
  } catch (e) {
    console.error(e)
  } finally {
    debouncedIdx[key] = setTimeout(fn, timeout)
  }
}

export const compareChatsByLastMessage = (chat1, chat2) => {
  if (isNil(chat1.last_message) || isNil(chat2.last_message)) {
    if (isNil(chat1.last_message) && !isNil(chat2.last_message)) {
      return -1
    }
    if (!isNil(chat1.last_message) && isNil(chat2.last_message)) {
      return 1
    }
    if (isNil(chat1.last_message) && isNil(chat2.last_message)) {
      return 0
    }
  }
  return moment(chat2.last_message.created_at).diff(
    chat1.last_message.created_at
  )
}
